import { createContext, useState, useContext, ReactNode } from 'react';

export interface PreviewData {
  firstname?: string | null;
  lastname?: string | null;
  username?: string | null;
  email?: string | null;
  mobile?: string | null;
  summary?: string | null;
  profileImage?: string | null;
  roles?: { name: string }[];
  jobAssignment?: { title?: string };
  skills?: {
    id: number | string;
    skill_name: string;
    rating_score: number;
    max_score: number;
    rating_label: string;
    endorsements_count?: number;
  }[];
  _rawFormState?: any;
}

interface PreviewContextType {
  previewData: PreviewData | null;
  setPreviewData: (data: PreviewData | null) => void;
}

const PreviewContext = createContext<PreviewContextType | undefined>(undefined);

export const PreviewProvider = ({ children }: { children: ReactNode }) => {
  const [previewData, setPreviewData] = useState<PreviewData | null>(null);

  return (
    <PreviewContext.Provider value={{ previewData, setPreviewData }}>
      {children}
    </PreviewContext.Provider>
  );
};

// Safe no-op fallback: profile sections are now widgets that can render in
// contexts WITHOUT a PreviewProvider (dashboard builder preview, home
// dashboards). Outside a provider, preview mode is simply "off" — throwing
// here crashed the whole dashboard builder.
const NO_PREVIEW: PreviewContextType = {
  previewData: null,
  setPreviewData: () => {},
};

export const usePreview = () => {
  const context = useContext(PreviewContext);
  return context ?? NO_PREVIEW;
};